























import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import SetRealizedGoalPriceTrigger from './SetRealizedGoalPriceTrigger.coffee'

settings =
  name: 'SetRealizedGoalPriceTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton }
    mixins: [SetRealizedGoalPriceTrigger.trigger()]

    methods:
      modalData: ->
        goal_for_realized_final_price: @modal.config.goal_for_realized_final_price

      hiSave: ->
        goalPrice = parseFloat(@modal.data.goal_for_realized_final_price)
        @modal.data.goal_for_realized_final_price = goalPrice
        @execute()

export default VueOptions.vue settings
